import React from "react";

const CampaignsMsgSvg = ({
  color = "#F5F5F5",
  height = "40",
  width = "40",
}) => {
  return (
    <svg
      width={width + ""}
      height={height + ""}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.7913 13.8926C8.7276 13.8926 8.66775 13.8751 8.6156 13.8453L12.3221 10.1392L13.2062 10.7821C13.376 10.947 13.5996 11.0373 13.838 11.0373C14.0763 11.0373 14.3 10.9466 14.4697 10.7821L15.3538 10.1392L19.0603 13.8457C19.0085 13.8754 18.9487 13.8929 18.8846 13.8929H8.7913V13.8926Z"
        stroke={color}
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M12.0543 9.9442L8.4385 13.5601C8.43815 13.5531 8.43745 13.5461 8.43745 13.5387V7.31465L12.0543 9.94455V9.9442Z"
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M19.0848 7.02135L14.2674 10.5242L14.2569 10.5319L14.2478 10.541C14.139 10.6498 13.9934 10.7097 13.838 10.7097C13.6826 10.7097 13.537 10.6498 13.4281 10.541L13.419 10.5319L8.5911 7.02135C8.64815 6.9818 8.7171 6.9587 8.7913 6.9587H18.8843C18.9585 6.9587 19.0274 6.98215 19.0845 7.02135H19.0848Z"
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M19.2385 13.5384C19.2385 13.5457 19.2378 13.5527 19.2374 13.5597L15.6216 9.94385L19.2385 7.31395V13.5384Z"
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M11.6669 5.26015H2.76815C2.3429 5.26015 1.99815 5.6049 1.99815 6.03015V11.5563C1.99815 11.9815 2.3429 12.3263 2.76815 12.3263H4.2063C3.9816 13.6164 3.60815 14.7168 3.3621 15.3555C3.3096 15.4913 3.40305 15.652 3.4846 15.5669C4.76 14.2362 5.65775 13.1747 6.2825 12.3263H11.6673C12.0925 12.3263 12.4373 11.9815 12.4373 11.5563V6.03015C12.4373 5.6049 12.0925 5.26015 11.6673 5.26015H11.6669Z"
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default CampaignsMsgSvg;
